jQuery(document).ready(function () {
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };

  function getLastWordFromURL() {
    var url = window.location.href;
    var parts = url.split("/");
    var lastPart = parts[parts.length - 1] || parts[parts.length - 2]; // Handle trailing slash
    return lastPart;
  }

  var page = __st.p;

  if (page == "product") {
    var prod_id = __st.rid;
    var prod_title = jQuery(".product-form .title-row .title").text();
    var productHandle = jQuery(".product-form .title-row .title").data(
      "product-handle"
    );
    var imageUrl = jQuery(".product-form .title-row .title").data("image-url");
    var price = jQuery(".price-container .main-price-ct .current-price").text();
    var amount = price.replace("₹ ", "");

    var utm_source = getUrlParameter("utm_source");
    if (utm_source != false) {
      var utm_medium = getUrlParameter("utm_medium");
      var utm_campaign = getUrlParameter("utm_campaign");

      var source = "Social";
    } else {
      var utm_source = "";
      var utm_medium = "";
      var utm_campaign = "";

      var source = "Direct";
    }
    var prod_sku=jQuery("[name='id'] option:selected").attr("data-sku");

    clevertap.event.push("Viewed Product", {
      source: source,
      sku: prod_sku,
      product_name: prod_title,
      product_category: "",
      product_url: productHandle,
      product_image: imageUrl,
      product_price: amount,
      utm_campaign: utm_campaign,
      utm_medium: utm_medium,
      utm_source: utm_source,
    });
  } else if (page == "collection") {
    var utm_source = getUrlParameter("utm_source");
    if (utm_source != false) {
      var utm_medium = getUrlParameter("utm_medium");
      var utm_campaign = getUrlParameter("utm_campaign");
      var source_page = "social";
      var source = "Social";
    } else {
      var utm_source = "";
      var utm_medium = "";
      var utm_campaign = "";
      var source_page = "";
      var source = "Direct";
    }
    var collection_title = jQuery(
      ".container  .overlay-text__inner .overlay-text__title"
    ).text();
    var collection_url = window.location.href;
  } else if (page == "home") {
    var utm_source = getUrlParameter("utm_source");
    if (utm_source != false) {
      var utm_medium = getUrlParameter("utm_medium");
      var utm_campaign = getUrlParameter("utm_campaign");
      var source_page = "social";
      var source = "Social";
    } else {
      var utm_source = "";
      var utm_medium = "";
      var utm_campaign = "";
      var source_page = "";
      var source = "Direct";
    }
    var collection_title = jQuery(
      ".container  .overlay-text__inner .overlay-text__title"
    ).text();
    var collection_url = window.location.href;
    if (__st.cid != undefined) {
      var user_id = __st.cid;
    } else {
      var user_id = "";
    }
    var d = new Date();
    clevertap.event.push("ViewedHomepage", {
      source: source,
      timestamp: d,
      user_id: user_id,
      utm_campaign: utm_source,
      utm_medium: utm_medium,
      utm_source: utm_source,
    });
  } else if (page == "page") {
    var lastWord = getLastWordFromURL();
    page = lastWord;
  } else {
    var lastWord = getLastWordFromURL();
    page = lastWord;
  }
  jQuery(document).on("click", ".mm-ajaxcart-open", function () {
    clevertap.event.push("Clicked Cart");
  });

  /******* Recently Viewd Product Clicked *********/
  jQuery(document).on(
    "click",
    ".ct-recently-viewed li .card a:first",
    function () {
      var title = jQuery(this).attr("data-title");

      clevertap.event.push("Clicked Recently Viewed", {
        "Product name": title,
        "Page Name": page,
      });
    }
  );
  /******* User Account icon  Clicked *********/
  jQuery(document).on("click", ".header-account-link", function () {
    clevertap.event.push("Clicked Profile Icon", {
      interaction_type: page,
    });
  });

  /******* User Wishlist icon  Clicked *********/
  jQuery(document).on("click", ".header_hhrt", function () {
    clevertap.event.push("Clicked Wishlist Icon", {
      "page name": page,
    });
  });

  /******* User Header Wishlist icon  Clicked *********/
  jQuery(document).on("click", ".header_hhrt", function () {
    clevertap.event.push("Clicked Wishlist Icon", {
      "page name": page,
    });
  });
  /******* Product Wishlist icon  Clicked *********/
  jQuery(document).on("click", ".zoomywishidheart .zoomycheck", function () {
    var $this = jQuery(this).closest(".zoomywishid");
    var title = $this.attr("data-title");
    var prod_price = $this.attr("data-price");
    var prod_id = $this.attr("data-product-id");
    var page_url = __st.pageurl;

    clevertap.event.push("Wishlisted", {
      wishlisted_product_type: "",
      wishlisted_product_name: title,
      wishlisted_product_price: prod_price,
      wishlisted_product_id: prod_id,
      page_url: page_url,
    });
  });
  /******* Click on Begin Checkout button*********/
  jQuery(document).on("click", ".ct_snapmint_checkout", function (e) {
    clevertap.event.push("Begin Checkout");
  });

  /******* Click Remove button on cart drawer*********/
  jQuery(document).on("click", ".mm-ajaxcart-remove-item", function (e) {
    e.preventDefault();
    let product_data = {
      "product_id": jQuery(this).closest('li').data("prod-id"),
      "product_name": jQuery(this).closest('li').data("prod-title"),
      "product_price": jQuery(this).closest('li').attr("data_main_price"),
      "page_url": __st.pageurl,
      "sku": jQuery(this).closest('li').attr("data-sku"),
      "product_quantity": 1,
    };

    clevertap.event.push("RemoveFromCart", product_data);
    return true;
  });
  /******* Click on Banner *********/
  jQuery(document).on(
    "click",
    ".mm-ajaxcart-remove-item.slick-current.slick-active a",
    function () {
      // clevertap.event.push("BannerClicked", {
      //                   "BannerID":
      //                   "BannerPosition":
      //                   "DestinationPageURL":
      //                   "BannerName":
      //                 });
    }
  );

  /******* Click on humburger menu *********/
  jQuery(document).on("click", "#pageheader .mobile-nav-toggle", function () {
    clevertap.event.push("HamburgerMenuUsed");
  });

  /******* Click on Similar Product Click*********/

  jQuery(document).on("click", ".CT_product-block .product-link", function () {
    var prod_id = jQuery(this)
      .closest(".CT_product-block")
      .attr("data-product-id");
    clevertap.event.push("SimilarProductClicked", {
      ProductID: prod_id,
    });
  });

  /******* Click on Product Image *********/
  jQuery(document).on(
    "click",
    ".product-media  .CT-rimage__image",
    function () {
      var prod_title = jQuery(".product-form .title-row .title").text();
      clevertap.event.push("Product Image Clicked", {
        product_name: prod_title,
      });
    }
  );

  /******* Click on Cart Icon click  *********/
  jQuery(document).on("click", ".mm-ajaxcart-open", function () {
    clevertap.event.push("Clicked Cart");
  });

  /******* Click on Banner Click  *********/
  jQuery(document).on(
    "click",
    ".slick-track .ct_slide .image-overlay__image-link",
    function () {
      var destination = jQuery(this).attr("href");
      var banner_position = jQuery(this)
        .closest(".ct_slide")
        .attr("data-slick-index");
      var segments = destination.split("/");
      var banner_name = segments.pop() || segments.pop(); // Handles trailing slash

      clevertap.event.push("BannerClicked", {
        BannerID: banner_position,
        BannerPosition: banner_position,
        DestinationPageURL: destination,
        BannerName: banner_name,
      });
    }
  );
  /******* Click on Banner Click for ALL Others   *********/
  jQuery(document).on("click", ".ct_banner_click_clevertap", function (e) {
    e.preventDefault(); // Prevent immediate redirect

    var destination = jQuery(this).attr("href");
    var banner_position = jQuery(this).attr("data-count");
    var segments = destination.split("/");
    var banner_name = segments.pop() || segments.pop(); // Handles trailing slash

    // Push event to CleverTap
    clevertap.event.push("BannerClicked", {
      BannerID: banner_position,
      BannerPosition: banner_position,
      DestinationPageURL: destination,
      BannerName: banner_name,
    });

    // Redirect after a slight delay to ensure the event is sent
    setTimeout(function () {
      window.location.href = destination;
    }, 500); // Adjust the delay if needed
  });

  /******* Click on Location Click  *********/
  jQuery(document).on("click", ".ct_location", function () {
    var page_name = getLastWordFromURL();

    clevertap.event.push("Clicked Store Locator", {
      page_name: page_name,
    });
  });

  /******* Click on Banner click  *********/
  jQuery(document).on(
    "click",
    "img[data-image='ct-clever_image']",
    function () {
      var page_url = window.location.href;

      clevertap.event.push("BannerClicked", {
        page_url: page_url,
      });
    }
  );
  /******* Click on collection sort by  *********/
  jQuery(document).on("click", ".CT_link-dropdown__options a", function () {
    var ct_sort = jQuery(this).find(".ct_cl_sort").text();
    var page_url = window.location.href;
    clevertap.event.push("Sort Applied", {
      sort_type: ct_sort,
      landingpage_url: page_url,
    });
  });
  /******* Click on Product description  *********/
  jQuery(document).on("click", ".cc-accordion-item__title", function () {
    clevertap.event.push("checked_product_description", {
      checked_product_description: "click",
    });
  });
  /******* Click on humburger menu *********/
  jQuery(document).on("click", ".mobile-nav-toggle", function () {
    clevertap.event.push("Clicked Navigation");
  });

  /******* Click on Login Btn *********/
  jQuery(document).on("click", "#customer .action_bottom button", function (e) {
    var email = jQuery("#customer_email").val();
    var password = jQuery("#customer_password").val();
    if (email != "" && password != "") {
      clevertap.event.push("Login", {
        Method_Used: "shopify",
        Login_Status: "success",
      });
    } else {
      if (email != "" && password != "") {
        clevertap.event.push("Login", {
          Method_Used: "shopify",
          Login_Status: "failed",
        });
      }
    }
  });

  $("#one-click-social-login-buttons-1").on("load", function () {
    var iframeContent = $(this).contents(); // Access the iframe content

    iframeContent.find(".btn-google-plus").on("click", function (event) {
      event.preventDefault(); // Prevent the default googleLogin() from being called
      alert("Custom Google Login triggered");

      // Your custom login logic goes here
      clevertap.event.push("Login", {
        Method_Used: "Google",
        Login_Status: "success",
      });

      // Optionally, open Google login window or redirect
      // window.open('YOUR_GOOGLE_LOGIN_URL', '_blank'); // replace with actual login URL
    });

    iframeContent.find(".btn-facebook").on("click", function (event) {
      event.preventDefault(); // Prevent the default googleLogin() from being called
      alert("Custom Google Login triggered");

      // Your custom login logic goes here
      clevertap.event.push("Login", {
        Method_Used: "facebook",
        Login_Status: "success",
      });

      // Optionally, open Google login window or redirect
      // window.open('YOUR_GOOGLE_LOGIN_URL', '_blank'); // replace with actual login URL
    });
  });

  /******* Click on Sign up Btn *********/
  jQuery(document).on("click", "#customer .action_bottom button", function (e) {
    var email = jQuery("#email").val();
    var password = jQuery("#password").val();
    if (email != "" && password != "") {
      clevertap.event.push("Sign Up", {
        Method_Used: "shopify",
        "Signup _Status": "success",
      });
    } else {
      if (email != "" && password != "") {
        clevertap.event.push("Sign Up", {
          Method_Used: "shopify",
          "Signup _Status": "failed",
        });
      }
    }
  });

  /******* Search input click *********/
  jQuery(".main-search__input_st").on("keypress", function (event) {
    if (event.which === 13) { // 13 is the keycode for Enter
      var searchQuery = jQuery(this).val().trim();
      if (searchQuery !== "") {
        var search = {
          page_name: page,
          search_query: searchQuery,
        };
        clevertap.event.push("Clicked Search Bar", search);
      }
    }
  });
  /******* Auto suggesation Search input click *********/
  jQuery(document).on(
    "click",
    ".wizzy-autocomplete-suggestions .autocomplete-suggestions-list .autocomplete-item",
    function (e) {
      e.preventDefault();
     var search_tearm = jQuery.trim(jQuery(this).text());
      var search = {
        AutoSuggestion_value: search_tearm,
      };
      clevertap.event.push("Search AutoSuggestion_clicked", search);
      //alert(JSON.stringify({"Search AutoSuggestion_clicked":search}, null, 2));
      setTimeout(function () {
         return true;
      }, 500);
    }
  );
  jQuery(document).on(
    "click",
    ".autocomplete-top-products .topproduct-item a",
    function (e) {
      e.preventDefault();
      var search_tearm = jQuery(this).closest("li").attr("title");
      var a_link = jQuery(this).attr("href");

      var search = {
        AutoSuggestion_value: search_tearm,
      };
      clevertap.event.push("Search AutoSuggestion_clicked", search);
      setTimeout(function () {
        window.location.href = a_link;
      }, 500);
      // alert(JSON.stringify({"Search AutoSuggestion_clicked":search}, null, 2));
    }
  );

  /******* hamburger menu click *********/
  jQuery(document).on("click", ".ct_navigation__item", function () {
    var item = jQuery(this).find(".navigation__link:first").text();
    var main_menu_click = {
      "Item Name": item,
    };
    clevertap.event.push("HamburgerMenu Item Clicked", main_menu_click);
  });

  /******* hamburger menu click *********/
  jQuery(document).on(
    "click",
    ".navigation__tier-3 .navigation__item",
    function () {
      var item = jQuery(this).find(".navigation__link:first").text();
      var main_menu_click = {
        "Item Name": item,
      };
      clevertap.event.push("Hamburger Submenu Clicked", main_menu_click);
    }
  );
  /******* All circle click event *********/
  jQuery(document).on("click", ".all_circle_click_clickpost", function (e) {
    e.preventDefault();
    var link = jQuery(this).attr("href");
    var collection_title = jQuery(
      ".container  .overlay-text__inner:first .overlay-text__title"
    ).text();
    var coll_name = jQuery(this).attr("data-name");
    var page_url = window.location.href;
    var circle_coll_click = {
      "Category Name": collection_title,
      "Page URL": page_url,
      "Landing Page URL": link,
    };
    clevertap.event.push("Circle Menu Clicked", circle_coll_click);
    setTimeout(function () {
      window.location.href = link;
    }, 500);
  });

  jQuery(document).on("click", ".call-banner a", function (e) {
    e.preventDefault();
    var link = jQuery(this).attr("href");
    var lastWord = getLastWordFromURL();
    var bridal = {
      Phone: link,
      Page: lastWord,
    };
    clevertap.event.push("Call_Stylist", bridal);
    setTimeout(function () {
      window.location.href = link;
    }, 500);
  });
});
